import { ProcessingIcon } from "./ProcessingIcon"

export const PageLoader = () => {
  // Todo cusom colors
  return <div className="h-dvh w-full pt-40  flex justify-center ">
    <ProcessingIcon />
  </div>
}
